import {Node} from 'tiptap'
export default class ScreenShot extends Node {

    get name() {
        return 'screenshot'
    }

    get schema() {
        return {
            attrs: {
                'data-id': {
                    default: null,
                },
                'data-href': {
                    default: null,
                },
                'data-small': {
                    default: null,
                },
                'preload': {
                    default: null,
                },
            },
            inline: true,
            group: 'inline',
            selectable: true,
            draggable: true,
            parseDOM: [
                {
                    tag: 'span.image',
                    getAttrs: dom => ({
                        'data-small': dom.getAttribute('data-small'),
                        'data-href': dom.getAttribute('data-href'),
                        'data-id': dom.getAttribute('data-id'),
                    }),
                },
            ],
            toDOM: node => {
                return [
                    'span',
                    {
                        'class': 'image',
                        'data-small': node.attrs['data-small'],
                        'data-href': node.attrs['data-href'],
                        'data-id': node.attrs['data-id'],
                        'style': 'background-image: url('+node.attrs['data-small']+');',
                        'clickprevent': '$emit(show,\''+node.attrs['data-id']+'\')',
                    },
                ]
            },
        }
    }

    get view() {
        return {
            props: ['node', 'updateAttrs', 'view'],
            computed: {
                small: {
                    get() {
                        return this.node.attrs['data-small'] ? this.node.attrs['data-small'] : this.node.attrs['data-href']
                    },
                    set(small) {
                        this.updateAttrs({
                            'data-small':small,
                        })
                    },
                },
                id: {
                    get() {
                        return this.node.attrs['data-id']
                    },
                    set(id) {
                        this.updateAttrs({
                            'data-id':id,
                        })
                    },
                },
            },
            methods: {
                showFullScreen(id) {
                    document.dispatchEvent(new CustomEvent('showimage', { detail: id }));
                },
            },
            template: `<span class="image" @click="showFullScreen(id)" :style="{'background-image': 'url('+small+')'}">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>`,
        }
    }

    commands({ type }) {
        return {
            screenshot: attrs => (state, dispatch) => {
                const preloadId = attrs.preload;
                let  preloadPos = false;
                state.tr.doc.descendants((node, pos) => {
                    if(node.type.name == 'image_preloader'){
                        if(preloadId == node.attrs['data-id']){
                            preloadPos = pos;
                        }
                    }
                })
                const { selection } = state
                const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
                const node = type.create(attrs)
                let transaction
                if(preloadPos){
                    transaction = state.tr.replaceWith(preloadPos,preloadPos+1, node)
                } else {
                    transaction = state.tr.insert(position  , node)
                }
                dispatch(transaction)
            },
        }
    }

}
